// utils/imageImports.js
export const menuImages = {
  porota: () => import('../../assets/images/porota.webp'),
  chapati: () => import('../../assets/images/chapati.avif'),
  puri: () => import('../../assets/images/puri.jpg'),
  idli: () => import('../../assets/images/idli.png'),
  dosa: () => import('../../assets/images/dosa.jpg'),
  chickenBiriyani: () => import('../../assets/images/chicken biriyani.png'),
  brickRice: () => import('../../assets/images/barik Rice.avif'),
  mataRice: () => import('../../assets/images/MATA RICE.webp'),
  fishFry: () => import('../../assets/images/fish fry.jpg'),
  chicken65: () => import('../../assets/images/chicken 65.jpg'),
  chickenKuruma: () => import('../../assets/images/chicken kuruma.avif'),
  chickenMasala: () => import('../../assets/images/chicken masala.webp'),
  kadalaCurry: () => import('../../assets/images/kadal kari.jpg'),
  eggCurry: () => import('../../assets/images/egg kari.png'),
  vegMix: () => import('../../assets/images/veg mix.webp'),
  normalGravy: () => import('../../assets/images/normal gravy.jpg'),
  eggRoast: () => import('../../assets/images/egg roast.jpg'),
  kottu: () => import('../../assets/images/Kottu.jpg'),
  friedRice: () => import('../../assets/images/fired Rice.png'),
  peperMasala: () => import('../../assets/images/peperMasala.webp'),
  kabab: () => import('../../assets/images/kabab.png'),
  omlet: () => import('../../assets/images/omlet.jpg'),
  vannila: () => import('../../assets/images/vannila.png'),
  chocolate: () => import('../../assets/images/chocolate.png'),
  strawberry: () => import('../../assets/images/strawbarry.webp'),
  pinapple: () => import('../../assets/images/pinapple.jpg'),
  grape: () => import('../../assets/images/grape.jpg'),
  mintLime: () => import('../../assets/images/mint lime.avif'),
  chakkanoodles: () => import('../../assets/images/c-hakka-noodles.png'),
  vhakkanoodles: () => import('../../assets/images/v-hakka-noodles.png'),
  ehakkanoodles: () => import('../../assets/images/e-hakka-noodles.jpg'),
  schezwanChicken: () => import('../../assets/images/schezwanChicken.avif'),
  schezwanEgg: () => import('../../assets/images/schezwanEgg.avif'),
  schezwanVeg: () => import('../../assets/images/schezwanVeg.jpg'),
  steamCMomo: () => import('../../assets/images/CHICKEN STEAM MOMO.jpg'),
  FriedCMomo: () => import('../../assets/images/CHICKEN FRIED MOMO.webp'),
  spicyCMomo: () => import('../../assets/images/spicyMomo.avif'),
  jholMomo: () => import('../../assets/images/jhol-momo.jpg'),
  muttonChilli: () => import('../../assets/images/muttonChilli.webp'),
  butterprawn: () => import('../../assets/images/butterPrawn.webp'),
  chilliPaneer: () => import('../../assets/images/chilliPaneer.webp'),
};